import { requestStatus } from "@/dictionary/requestStatus";

const state = {
  mixWholeSaleConfig: {},
};
const getters = {};
const mutations = {
  getOpQueryMarketingMixConfigSuccess(state, data) {
    state.mixWholeSaleConfig = {
      status: requestStatus.success,
      data,
    };
  },
  getOpQueryMarketingMixConfigError(state, error) {
    state.mixWholeSaleConfig = {
      status: requestStatus.success,
      data: {},
      error,
    };
  },
};
const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
